export const defaultLocale = 'en-US';

// character length constraints
export const acquisitionLabelMaxLength = 128;
export const labelMinLength = 2;
export const labelMaxLength = 64;
export const bucketMaxLength = 63;
export const urlMinLength = 3;
export const userNameMaxLength = 32;
export const STORAGE_UNIT_SIZE = 1000;
export const INT32_MAX = Math.pow(2, 31) - 1;
